import {
  ACCOMMODATION_TYPE_HUB_PATHS,
  isAccommodationTypeSearchPath,
  getAccommodationTypeCitySlugFromPath,
  buildColivingCanonicalUrl,
  COLIVING_MARKETPLACE_HUB,
} from '../../../shared/accommodationTypeSeo.cjs';

export {
  ACCOMMODATION_TYPE_HUB_PATHS as ACCOMMODATION_TYPE_PATH_PREFIXES,
  isAccommodationTypeSearchPath,
  getAccommodationTypeCitySlugFromPath,
  buildColivingCanonicalUrl,
  COLIVING_MARKETPLACE_HUB,
};

/** @deprecated usa isAccommodationTypeSearchPath */
export const isAccommodationTypeLandingPath = isAccommodationTypeSearchPath;

export function getAccommodationTypeFromRoute(route) {
  return route?.meta?.accommodationType || null;
}

/**
 * Precarga filtros del buscador según la landing de tipo de alojamiento.
 * @returns {boolean} si se aplicó algún preset
 */
export function applyAccommodationTypeLandingFilters(accommodationType, filters) {
  if (!accommodationType || !filters) return false;

  switch (accommodationType) {
    case 'temporary-rooms':
      filters.maxMinimumStay = 6;
      break;
    case 'all-inclusive':
      filters.services.allIncluded = true;
      break;
    case 'flexliving-apartments':
      filters.accommodationType.apartment = true;
      filters.accommodationType.building = false;
      break;
    case 'digital-nomads':
      filters.services.internet = true;
      break;
    case 'professionals':
      filters.maxMinimumStay = 12;
      break;
    default:
      return false;
  }
  return true;
}
